module.exports = __webpack_public_path__ + "static/img/fdmBanner.c0fd9dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fdmBanner.png
// module id = onH3
// module chunks = 2